module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="gut-check__counter hidden"><span class="js-gut-check-count">1</span> of ' +
__e( totalSteps ) +
'</div>\n<div>\n    ';
 if (showIntro) { ;
__p += '\n    <div class="gut-check__section gut-check__section--intro">\n        <img src="' +
__e( $.staticURL('gutcheck-icon.png') ) +
'" class="gut-check__icon" alt="gut check icon" />\n        <p>\n            Let\'s check that you\'ve included the details that will maximize\n            your chances of success for these jobs\n        </p>\n        <a href="#" class="gut-check__button js-gut-check-next">Continue</a>\n    </div>\n    ';
 } ;
__p += '\n    ';
 keywords.forEach(function(keyword) { ;
__p += '\n    <div class="gut-check__section hidden">\n        <p class="gut-check__section-text">\n            Does this history clearly show your:<br />\n            <em>' +
__e( keyword.answer ) +
'</em> experience in ' +
__e( keyword.keyword ) +
'?\n        </p>\n        <div class="gut-check__buttons">\n            <a href="#" class="js-gut-check-no">Maybe not</a>\n            <a href="#" class="gut-check__button js-gut-check-yes" data-keyword="' +
__e( keyword.keyword ) +
'">Yes, I think so</a>\n        </div>\n    </div>\n    ';
 }) ;
__p += '\n    <div class="gut-check__section gut-check__section--outro hidden">\n        <div class="js-gut-check-outro-recommend">\n            <header>Recommendations:</header>\n            <p>\n                <strong>Add missing jobs</strong> and <strong>update job descriptions</strong>\n                and job titles to clearly show your experience:\n            </p>\n            ';
 if (keywords.length > 0) { ;
__p += '\n            <ul>\n                ';
 keywords.forEach(function(keyword) { ;
__p += '\n                    <li data-keyword="' +
__e( keyword.keyword) +
'">\n                        ' +
__e( _.upperFirst(keyword.keyword) ) +
' (' +
__e( keyword.answer ) +
')\n                    </li>\n                ';
 }) ;
__p += '\n            </ul>\n            ';
 } ;
__p += '\n            ';
 if (skill) { ;
__p += '\n            <p class="gut-check__warning">\n                ';
 if (!skill.total) { ;
__p += '\n                    You haven\'t listed any work experience.\n                ';
 } else { ;
__p += '\n                    You\'ve listed only ' +
__e( skill.total ) +
' of total work experience.\n                ';
 } ;
__p += '\n            </p>\n            ';
 } ;
__p += '\n            <p>\n                Click "I\'m done updating" when you\'re ready to move on\n            </p>\n        </div>\n        <div class="js-gut-check-outro-complete">\n            <p>Thanks for going through these checks with us&mdash;we just want your profile to show you off :)\n            <p><strong>Click "Next" to continue</strong></p>\n        </div>\n    </div>\n</div>\n';

}
return __p
}